import { createQueryKeys } from '@lukemorales/query-key-factory';

import API from '../../index';
import {
  GetBaseGuidelineRulesRequestParams,
  GetGuidelineRulesRequestParams,
} from './guidelineRules.types';

export const GUIDELINE_RULE_DTO_ENUMS = {
  GROUP_NAME: {
    REELS_REQUESTS: 'REELS_REQUESTS',
    /** 참고 릴스 */
    REELS_REFERENCE: 'REELS_REFERENCE',
    /** 참고 릴스에서 참고했으면 하는 점 */
    REELS_REFERENCE_DESCRIPTION: 'REELS_REFERENCE_DESCRIPTION',
    /** 기타 전달사항 */
    OTHER_REQUESTS: 'OTHER_REQUESTS',
    /** 필수 문구 */
    MANDATORY_PHRASE: 'MANDATORY_PHRASE',
    /** Fashion 필수 가이드라인 */
    PROHIBITIONS: 'PROHIBITIONS',
    /** Beauty 필수 가이드라인 */
    PROHIBITIONS_BEAUTY: 'PROHIBITIONS_BEAUTY',
    REQUIREMENTS: 'REQUIREMENTS',
    /** 해시태그 위치 */
    HASH_TAG_LOCATION: 'HASH_TAG_LOCATION',
    /** 타 브랜드 태그 허용 여부 */
    ALLOW_OTHER_AT_TAG: 'ALLOW_OTHER_AT_TAG',
    /** 광고 태그 허용 여부 */
    ALLOW_ADVERTISEMENT_TAG: 'ALLOW_ADVERTISEMENT_TAG',
    /** 가이드 이미지 */
    GUIDE_IMAGE: 'GUIDE_IMAGE',
    /** 브랜드 로고 이미지 */
    BRAND_LOGO: 'BRAND_LOGO',
    /** 브랜드의 인스타그램 공식 계정 */
    AT_TAGS: 'AT_TAGS',
    /** 포스팅 시 삽입할 해시태그 */
    HASH_TAGS: 'HASH_TAGS',
    /** 제품 착용샷 - 정면으로 서서 (머리, 발끝 잘리지 않게) */
    PHOTO_MODEL_FULL: 'PHOTO_MODEL_FULL',
    /** 제품 착용샷 - 반신샷 */
    PHOTO_MODEL_HALF: 'PHOTO_MODEL_HALF',
    /** 제품 착용샷 - 제품 디테일 클로즈업 */
    PHOTO_MODEL_CLOSEUP: 'PHOTO_MODEL_CLOSEUP',
    /** 제품 단독 컷 */
    REELS_PRODUCT: 'REELS_PRODUCT',
    /** 패키지 단독 컷 */
    REELS_PRODUCT_PACKAGE: 'REELS_PRODUCT_PACKAGE',
    /** 제형 표현 컷 */
    REELS_PRODUCT_TEXTURE: 'REELS_PRODUCT_TEXTURE',
    /** 발색 표현 컷 */
    REELS_PRODUCT_COLOR: 'REELS_PRODUCT_COLOR',
    /** 제품 사용 컷 */
    REELS_PRODUCT_TRY: 'REELS_PRODUCT_TRY',
    /** 비포&애프터 컷 */
    REELS_PRODUCT_BEFORE_AFTER: 'REELS_PRODUCT_BEFORE_AFTER',
    /** 제품을 들고 찍은 셀피 컷 */
    REELS_PRODUCT_SELFIE: 'REELS_PRODUCT_SELFIE',
    /** 영상 최소 길이 */
    VIDEO_DURATION: 'VIDEO_DURATION',
    /** 1초 후킹멘트 */
    SUBTITLE_OPENING: 'SUBTITLE_OPENING',
    /** 성능/효과/사용법 */
    SUBTITLE_MIDDLE: 'SUBTITLE_MIDDLE',
    /** 행사 및 이벤트 */
    SUBTITLE_CLOSING: 'SUBTITLE_CLOSING',
    /** 포스팅 글 내용 */
    CONTENT: 'CONTENT',
    /** 공동 작업자 */
    CO_AUTHOR: 'CO_AUTHOR',
    /** 선호하는 영상 유형 */
    PREFERRED_VIDEO_TYPE: 'PREFERRED_VIDEO_TYPE',
    /** 파트너쉽 코드 */
    REQUIRE_PARTNERSHIP_CODE: 'REQUIRE_PARTNERSHIP_CODE',
    /** 클린본 영상 첨부 */
    ATTACHMENT_RAW_VIDEO: 'ATTACHMENT_RAW_VIDEO',
    /** 올리브영 세일 엠블럼 이미지 */
    EMBLEM_OLIVEYOUNG: 'EMBLEM_OLIVEYOUNG',
    /** 사전검수 피드백 관련 */
    INSPECTION_FEEDBACK_SEQUENCE: 'INSPECTION_FEEDBACK_SEQUENCE',
    SUBTITLE_FONT: 'SUBTITLE_FONT',
    SUBTITLE_SIZE: 'SUBTITLE_SIZE',
    BACKGROUND_MUSIC_EDIT: 'BACKGROUND_MUSIC_EDIT',
    NARRATION_ADD: 'NARRATION_ADD',
    NARRATION_EDIT: 'NARRATION_EDIT',
  },
  OUTPUT_TYPE: {
    /** 포스팅 */
    PHOTO: 1,
    /** 영상 */
    VIDEO: 2,
  },
  USER_TYPE_FL: {
    /** 증정 일반 */
    CAMPAIGN_NORMAL: 11,
  },
  TYPE: {
    /** 산출물 */
    OUTPUT: 1,
    /** 이미지 */
    IMAGE: 2,
    /** 금지사항 */
    PROHIBITION: 3,
    /** 텍스트 */
    TEXT: 4,
    /** 선택 */
    SELECT: 5,
    /** 필수사항 */
    REQUIREMENT: 6,
    /** 금지사항(뷰티 전용) */
    PROHIBITION_BEAUTY: 7,
  },
  /** 하위 그룹(value로 확인) */
  PROHIBITIONS_OPTIONS: {
    OTHER_PEOPLE: 'OTHER_PEOPLE',
    MIRROR_SELFIE: 'MIRROR_SELFIE',
    MASK: 'MASK',
    INDOORS: 'INDOORS',
    PLACE_ROOFTOP: 'PLACE_ROOFTOP',
  },
  /** 하위 뷰티 그룹(value로 확인) */
  PROHIBITIONS_BEAUTY_OPTIONS: {
    /** 겟레디윗미 금지, 증정 제품만 단독으로 소개 */
    GRWM_AND_OTHER_PRODUCTS: 'GRWM_AND_OTHER_PRODUCTS',
    /** 기초 제품인 경우, 반드시 생얼로 촬영 */
    MAKE_UP: 'MAKE_UP',
    /** 제품 색상 및 분위기와 어울리는 의상 권장 */
    TPO_MISMATCH: 'TPO_MISMATCH',
    /** 제품이나 거울의 지문과 먼지는 반드시 닦고 촬영 */
    FINGERPRINTS: 'FINGERPRINTS',
    /** 찍은 영상 확대 금지, 처음부터 클로즈업으로 촬영 */
    ENLARGE: 'ENLARGE',
    /** 사진 짜깁기 방식의 편집 금지 */
    SLIDESHOW: 'SLIDESHOW',
    /** 저작권 이슈가 없는 폰트 및 음원만 사용 */
    COMMERCIAL_CONTENTS: 'COMMERCIAL_CONTENTS',
    /** 아이폰인 경우 반드시 HDR 설정을 끄고 촬영 */
    HDR: 'HDR',
    /** 데드존에 자막, 로고 삽입 금지 */
    DEADZONE: 'DEADZONE',
  },
  VIDEO_DURATION_OPTIONS: {
    /** 20초 */
    TWOWENTY: 'TWOWENTY',
    /** 30초 */
    THIRTY: 'THIRTY',
  },
  PREFERRED_VIDEO_TYPE_OPTIONS: {
    /** 감성형 */
    EMOTIONAL: 'EMOTIONAL',
    /** 정보전달형 */
    INFOMATIVE: 'INFOMATIVE',
    /** 방문형 */
    VISITING: 'VISITING',
    /** 올리브영 방문형 */
    OY_VISITING: 'OY_VISITING',
    /** 올리브영 제품만 소개형 */
    OY_PRODUCT_ONLY: 'OY_PRODUCT_ONLY',
  },
  HASH_TAG_LOCATION_OPTIONS: {
    /** 포스팅 글 내에 포함 */
    POST: 'POST',
    /** 포스팅 댓글에 포함 */
    COMMENT: 'COMMENT',
  },
  ALLOW_OTHER_AT_TAG_OPTIONS: {
    /** 허용 */
    ALLOW: 'ALLOW',
    /** 허용하지 않음 */
    DISALLOW: 'DISALLOW',
  },
  ALLOW_ADVERTISEMENT_TAG_OPTIONS: {
    /** 포함 */
    ALLOW: 'ALLOW',
    /** 미포함 */
    DISALLOW: 'DISALLOW',
  },
  REQUIRE_PARTNERSHIP_CODE_OPTIONS: {
    /** 필요 */
    REQUIRED: 'REQUIRED',
    /** 필요하지 않음 */
    NOT_REQUIRED: 'NOT_REQUIRED',
  },
} as const;

export const guidelineRulesQueryKeys = createQueryKeys('guidelineRules', {
  getBaseGuidelineRules: (params: GetBaseGuidelineRulesRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.GuidelineRules.getBaseGuidelineRules(params),
  }),
  getGuidelineRules: (params: GetGuidelineRulesRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.GuidelineRules.getGuidelineRules(params),
  }),
});
